export default "__VITE_ASSET__096162bf__"